<template>
    <v-form @submit.prevent="saveMeal">
      <v-text-field v-model="customMeal.name" label="Meal Name"></v-text-field>
      <v-slider
        v-model="customMeal.points"
        :min="0"
        :max="10"
        :step="1"
        label="Points"
        thumb-label
      ></v-slider>
      <v-btn type="submit" color="primary">Save Custom Meal</v-btn>
    </v-form>
  </template>
  
  <script>
  export default {
    props: ['meal'],
    data() {
      return {
        customMeal: {
          name: '',
          points: 0,
        },
      };
    },
    methods: {
      saveMeal() {
        this.$emit('update:meal', { ...this.customMeal });
      },
    },
    created() {
      if (this.meal) {
        this.customMeal = { ...this.meal };
      }
    },
  };
  </script>